import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container"];

  connect() {
    // Find the button and click it automatically
    setTimeout(() => {
      const button = this.element.querySelector("#auto_close_button");
      if (button) button.click();
    }, 300); // Small timeout to ensure DOM is ready
  }
}
